$(document).ready(function () {
    if (document.getElementById('apdr-tarif-container')) {
        function formatEuro(price) {
            return price.toLocaleString('fr', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';
        }

        function calculTotal() {
            var totalChecked = (module1?.checked ?? 0) + (module2?.checked ?? 0) + (module3?.checked ?? 0);
            console.log(totalChecked);

            if (totalChecked < 2) {
                module1?.setAttribute('onclick', 'return ' + (module1 && !module1.checked ? 'true' : 'false'));
                module2?.setAttribute('onclick', 'return ' + (module2 && !module2.checked ? 'true' : 'false'));
                module3?.setAttribute('onclick', 'return ' + (module3 && !module3.checked ? 'true' : 'false'));
            } else {
                module1?.removeAttribute('onclick');
                module2?.removeAttribute('onclick');
                module3?.removeAttribute('onclick');
            }

            var totalMensuel = 0;
            var totalAnnuel = 0;

            if (module1?.checked) {
                totalMensuel += tarifs.module1.mensuel;
                totalAnnuel += tarifs.module1.annuel;
            }

            if (module2?.checked) {
                totalMensuel += tarifs.module2.mensuel;
                totalAnnuel += tarifs.module2.annuel;
            }

            if (module3?.checked) {
                totalMensuel += tarifs.module3.mensuel;
                totalAnnuel += tarifs.module3.annuel;
            }

            totalMensuelCont.innerText = formatEuro(totalMensuel);
            totalAnnuelCont.innerText = formatEuro(totalAnnuel);
        }

        var module1 = document.getElementById('module1-check');
        var module2 = document.getElementById('module2-check');
        var module3 = document.getElementById('module3-check');

        var totalAnnuelCont = document.getElementById('total-annuel');
        var totalMensuelCont = document.getElementById('total-mensuel');

        if (module1) {
            module1.onchange = calculTotal;
        }

        if (module2) {
            module2.onchange = calculTotal;
        }

        if (module3) {
            module3.onchange = calculTotal;
        }

        calculTotal();
    }
});
